import React from 'react';
import { Facebook, Instagram, Twitter, Send } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-simba-dark text-simba-cream pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Brand Column */}
          <div className="space-y-6">
            <span className="font-display font-bold text-2xl text-white tracking-tight">
              SIMBA<span className="text-simba-gold">HERBALS</span>
            </span>
            <p className="font-body text-simba-cream/70 leading-relaxed max-w-sm">
              Authentic African remedies crafted for strength, vitality, and natural wellness. Unleash your inner nature.
            </p>
            <div className="flex space-x-4 pt-2">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-simba-gold hover:text-simba-dark transition-all">
                <Facebook size={18} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-simba-gold hover:text-simba-dark transition-all">
                <Instagram size={18} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-simba-gold hover:text-simba-dark transition-all">
                <Twitter size={18} />
              </a>
            </div>
          </div>

          {/* Links Column */}
          <div>
            <h4 className="font-display font-bold text-lg mb-6 text-white">Explore</h4>
            <ul className="space-y-4 font-body text-simba-cream/70">
              <li><Link to="/shop" className="hover:text-simba-gold transition-colors">Shop All</Link></li>
              <li><Link to="/our-story" className="hover:text-simba-gold transition-colors">Our Story</Link></li>
              <li><Link to="/journal" className="hover:text-simba-gold transition-colors">Journal</Link></li>
              <li><Link to="/contact" className="hover:text-simba-gold transition-colors">Contact</Link></li>
              <li><Link to="/track-order" className="hover:text-simba-gold transition-colors">Track order</Link></li>
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h4 className="font-display font-bold text-lg mb-6 text-white">Legal</h4>
            <ul className="space-y-4 font-body text-simba-cream/70">
              {['Privacy Policy', 'Terms of Service', 'Shipping Info', 'Returns'].map((item) => (
                <li key={item}>
                  <Link to={`/${item.toLowerCase().replace(' ', '-')}`} className="hover:text-simba-gold transition-colors">{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="font-display font-bold text-lg mb-6 text-white">Stay Natural</h4>
            <p className="font-body text-simba-cream/70 mb-6">
              Subscribe for wellness tips and exclusive offers.
            </p>
            <div className="relative">
              <input 
                type="email" 
                placeholder="Your email address" 
                className="w-full bg-white/5 border border-white/10 rounded-full px-6 py-4 pr-12 text-white placeholder-simba-cream/30 focus:outline-none focus:border-simba-gold transition-colors font-body"
              />
              <button className="absolute right-2 top-2 w-10 h-10 bg-simba-gold rounded-full flex items-center justify-center text-simba-dark hover:bg-white transition-colors">
                <Send size={18} />
              </button>
            </div>
          </div>

        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center text-sm font-body text-simba-cream/40">
          <p>© {new Date().getFullYear()} Simba Herbals. All rights reserved.</p>
          <div className="mt-4 md:mt-0 flex items-center gap-4">
            <span className="hover:text-simba-gold cursor-pointer transition-colors">London, UK</span>
            <span className="h-3 w-px bg-white/20"></span>
            <a href="https://www.spemedia.co.zw/" target="_blank" rel="noopener noreferrer" className="hover:text-simba-gold transition-colors">
              Designed and Developed by speMedia
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
